import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  SxProps,
  Theme,
} from '@mui/material';
import { EntityType } from '../types';
import { ENTITY_TYPES } from '../constants';

interface EntitySelectorProps {
  value: EntityType | '';
  onChange: (value: EntityType | '') => void;
  label?: string;
  size?: 'small' | 'medium';
  sx?: SxProps<Theme>;
}

const EntitySelector: React.FC<EntitySelectorProps> = ({
  value,
  onChange,
  label = 'Entity Type',
  size = 'small',
  sx,
}) => {
  const handleChange = (event: SelectChangeEvent<EntityType | ''>) => {
    onChange(event.target.value as EntityType | '');
  };

  return (
    <FormControl sx={{ minWidth: 180, ...sx }} size={size}>
      <InputLabel>{label}</InputLabel>
      <Select value={value} label={label} onChange={handleChange}>
        <MenuItem value="">
          <em>Select an entity type</em>
        </MenuItem>
        {ENTITY_TYPES.map((type) => (
          <MenuItem key={type.value} value={type.value}>
            {type.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default EntitySelector;
